import {DetailTable} from '../../mapping-classes/detail-table';

export class Debitinterest implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(debitInterest: any) {
    if (!debitInterest || !debitInterest.basicTableData || debitInterest.basicTableData.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = debitInterest.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(debitInterest.basicTableData);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen debit interest gegevens gevonden.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'level',
      'interestPercentage',
      'linkId',
      'linkPercentage',
      'storePercentage',
      'minimumPercentage',
      'startDate',
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
        if (this.restrictedData) {
          details.interestPercentage = this.shieldedText;
          details.linkPercentage = this.shieldedText;
          details.storePercentage = this.shieldedText;
          details.minimumPercentage = this.shieldedText;
        }
        this.rowData.push(details);
    });
  }
}
